import {Basic, Ventrata} from 'types'
import {TotalPerBooking} from './TotalPerBooking'
import {TotalPerUnit} from './TotalPerUnit'

type Props = {
  product: Ventrata.Product
  currency: Basic.Currency
  availability?: Ventrata.Availability
  usedUnits: Ventrata.Unit[]
  counters: Record<string, number>
}
export const Total = ({product, currency, availability, usedUnits, counters}: Props) => {
  switch (product.pricingPer) {
    case 'BOOKING':
      return <TotalPerBooking availability={availability} currency={currency} />
    case 'UNIT':
      return <TotalPerUnit availability={availability} usedUnits={usedUnits} counters={counters} currency={currency} />
    default:
      return null
  }
}
